import ViewBase from "../views/view-base.view";
import WidgetContainerComponent from "../components/widget/widget-container.component";
import VocWidgetComponent from "../components/widget/voc-widget.component";
import vocModel from "../models/voc/voc.model";
import moment from "moment";
import { formats as FORMATS } from "../config/constants";

export default function VocWidget() {

  ViewBase.call(this);

  let vocSummary;
  let filterParams = {
    fromDate: moment().add(-6, 'w').format(FORMATS.apiDateFormat),
    toDate: moment().format(FORMATS.apiDateFormat),
  }

  let getVocSummary = () => {
    vocSummary = undefined;
    vocModel.getVocSummary(
      (result) => {
        vocSummary = result;
      },
      (error) => {
        this.handleError(error);
      },
      filterParams
    );
  };

  return {
    oninit: (vnode) => {
      getVocSummary();
    },
    view: (vnode) => {
      return [
        m(WidgetContainerComponent,
          {
            title: this.getText('LT00000114', 'VOC'),
            links: [
              {
                text: this.getText('LT00000108', 'Details'),
                url: '/voc'
              },
            ],
          }, [
          m(VocWidgetComponent, {
            data: vocSummary,
          })
        ]
        ),
      ]
    }
  }
}
